import { ResponsiveContainer, LineChart, Line } from 'recharts';
import { demoTheme } from '../../theme';

/** Kartin kucuk egrisi. Iki noktadan az veride cizilmez (tek nokta egri degildir). */
export function MiniEgri({ veri, testid }: { veri: number[]; testid: string }) {
  if (veri.length < 2) return null;
  const noktalar = veri.map((v, i) => ({ i, v }));
  return (
    <div data-testid={testid} data-nokta={veri.length} style={{ width: '100%', height: 32 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={noktalar} margin={{ top: 2, right: 0, left: 0, bottom: 2 }}>
          <Line type="monotone" dataKey="v" stroke={demoTheme.primary} strokeWidth={1.5} dot={false} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
